<template>
  <v-container grid-list-md text-xs-center>
    <v-card :loading="isLoading">
      <v-card-title>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12">
            <h1 class="headline">{{ $t('fines.new') }}</h1>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="1" md="2">
            <v-text-field v-model.number="fine.sum" data-testid="new-fine-sum" :label="$t('custom.amount')"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="3" md="5">
            <v-text-field v-model="fine.number" data-testid="new-fine-number" :label="$t('fines.number')"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="2" md="5">
            <vc-date-picker v-model="start_date" mode="dateTime" :attributes="attrs_calendar" is24hr
              :locale="$i18n.locale" :is-dark="$vuetify.theme.dark">
              <template v-slot="{ inputEvents }">
                <v-text-field :value="start_date_formatted" v-on="inputEvents" :label="$t('custom.date')" readonly
                  hide-details />
              </template>
            </vc-date-picker>
          </v-col>
          <v-col cols="12" xs="12" sm="2" md="2">
            <v-autocomplete v-model="selected_booking" :loading="isLoadingBookings" :search-input.sync="search_booking"
              flat clearable :label="$t('bookings.number_booking')" :items="bookings" return-object
              item-text="id_string" item-value="id"
              :hint="selected_booking && selected_booking.car ? selected_booking.car.code : ''">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="3" md="5">
            <v-autocomplete v-model="client" item-text="fullname" item-value="id" :loading="isLoadingClients"
              :search-input.sync="search_client" flat clearable hide-no-data hide-details
              :label="$t('bookings.select_client')" :items="clients" return-object>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="2" md="5">
            <v-select v-model="fine.state" clearable :items="fines_state" item-text="text" item-value="value"
              :label="$t('bookings.select_state')"></v-select>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-textarea v-model="fine.description" data-testid="new-fine-description" auto-grow rows="1" :label="$t('fines.description')"
              :placeholder="$t('fines.description_2')"></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn data-testid="new-fine-save" color="success" @click="submit()" :disabled="isLoading" :loading="isLoading">
          {{ $t("custom.save") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
export default {
  data() {
    return {
      fine: {
        sum: null,
        date: null,
        state: this.$t('fines_state.created'),
        description: null,
        number: null,
        client_id: null,
        booking_id: null,
        car_id: null,
        car_code: null,
      },
      selected_booking: null,
      start_date: null,
      start_date_formatted: null,
      date_format: null,
      start_date_menu: false,
      fines_state: [
        { text: this.$t('fines_state.created'), value: "Создан" },
        { text: this.$t('fines_state.notify'), value: "Оповещён" },
        { text: this.$t('fines_state.paid'), value: "Оплачен" },
        { text: this.$t('fines_state.refund'), value: "Возмещён" }
      ],
      attrs_calendar: [
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "outline",
            contentClass: "italic",
          },
          dates: new Date(),
        },
      ],
      search_client: null,
      clients: [],
      client: null,
      isLoadingClients: false,
      isLoadingBookings: false,
      workers: [],
      bookings: [],
      search_booking: null,
      selected_worker: null,
      timeout: null,
      isMobile: false,
      isLoading: false,
      error: ""
    }
  },
  created() {
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (!this.$store.getters.isLoggedIn) {
      this.$store.commit("unsetCurrentUser");
    }
  },
  watch: {
    search_client(val) {
      if (this.client) {
        return;
      }
      if (this.search_client == "" || this.search_client == " ") {
        this.search_client = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadClients();
          }, 300); // delay
        }
        debounce();
      }
    },
    search_booking(val) {
      if (this.fine.booking_id) {
        return;
      }
      if (typeof val === 'number') {
        this.search_booking = val.toString();
        return;
      }
      if (this.search_booking == "" || this.search_booking == " ") {
        this.search_booking = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadBookings();
          }, 300); // delay
        }
        debounce();
      }
    },
    start_date(val) {
      if (val) {
        this.start_date_formatted = moment(val).format("DD-MM-YYYY HH:mm");
      }
    },
  },
  computed: {
  },
  methods: {
    submit() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      if (this.isStaff) {
        if (this.fine.sum && this.fine.number) {
          this.isLoading = true;
          this.axios
            .post(
              "/api/v1/fines",
              {
                fines: {
                  sum: this.fine.sum,
                  date: this.start_date,
                  state: this.fine.state,
                  description: this.fine.description,
                  number: this.fine.number,
                  client_id: this.client ? this.client.id : null,
                  booking_id: this.selected_booking ? this.selected_booking.id : null,
                  car_id: this.selected_booking ? this.selected_booking.car_id : null,
                  car_code: this.selected_booking ? this.selected_booking.car_code : null,
                }
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken
                }
              }
            )
            .then(response => {
              this.$router.replace("/fines");
              this.$notify(this.$t('fines.added_success'), this.$t('fines.added_success_text'), "success", 3000);
            })
            .catch(error => {
              this.setError(error, this.$t('errors.fine_add'));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t('errors.all_fields_title'), this.$t('errors.fine_add_text'), "warning", 4000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    loadClients() {
      this.isLoadingClients = true;
      this.axios
        .post(
          `/api/v1/index_new_booking_page`,
          {
            search: this.search_client,
            meilisearch: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.clients = response.data.query ? response.data.query : (response.data ? response.data : []);
          this.clients.forEach((client) => {
            if (!client.entity) {
              client["fullname"] =
                client.lastname +
                " " +
                client.name +
                " " +
                client.middlename +
                " " +
                (client.phone
                  ? client.phone.slice(client.phone.length - 4)
                  : "");
            } else {
              client["fullname"] =
                client.entity_name +
                ", " +
                client.reg_form +
                " " +
                " - " +
                (client.entity_phone
                  ? client.entity_phone.slice(client.entity_phone.length - 4)
                  : "");
            }
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.clients_load"));
        })
        .finally(() => (this.isLoadingClients = false));
    },
    loadBookings() {
      this.isLoadingBookings = true;
      this.axios
        .get(`/api/v1/search_bookings`, {
          params: {
            booking_id: this.search_booking,
          },
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.bookings = response.data ? response.data : [];
          this.bookings.forEach((booking) => {
            booking.id_string = booking.id.toString();
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.bookings_load"));
        })
        .finally(() => (this.isLoadingBookings = false));
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    }
  },
  components: {
  }
};
</script>
